import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import UserInfo from '@/modules/profile/UserInfo'
import { fetchCurrentUserThunk } from '@/redux/slices/currentUserSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useEffect } from 'react'
import { Platform } from 'react-native'

export default function UserInfoPage() {
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector(state => state.currentUser.user)
  const headerLeftItems = useWebBackButton('/profile')
  const [groupedBg] = usePlatformColor('systemGroupedBackgroundColor')

  useEffect(() => {
    dispatch(fetchCurrentUserThunk())
  }, [dispatch])

  if (!currentUser) {
    return null
  }

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({ left: headerLeftItems }),
          ...(Platform.OS !== 'ios' && {
            headerStyle: { backgroundColor: groupedBg as string },
            contentStyle: { backgroundColor: groupedBg as string },
          }),
        }}
      />
      <UserInfo currentUser={currentUser} />
    </>
  )
}
